import { apiSlice } from '@services/apiSlice';
import { News as endpoints } from '@services/endpoints';
import { NewsList, NewsPage } from './NewsList.types';

interface NewsQueryParams {
  page: number;
  category: string;
  country: string;
  industries: string
  startDate: string;
  endDate: string;
}

const newsApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ['News'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchNewsPageData: build.query<NewsPage, void>({
        query: () => ({
          url: endpoints.fetchNews,
          params: { lang: window.lang, pageId: window.pageId },
        }),
      }),
      fetchNews: build.query<NewsList, NewsQueryParams>({
        query: (params) => ({
          url: endpoints.fetchNews,
          params: { lang: window.lang, pageId: window.pageId, ...params },
        }),
      }),
    }),
    overrideExisting: false,
  })

export const { useLazyFetchNewsQuery, useFetchNewsPageDataQuery } = newsApi;